import { render, staticRenderFns } from "./LikersList.vue?vue&type=template&id=36808f21&scoped=true&"
import script from "./LikersList.vue?vue&type=script&lang=js&"
export * from "./LikersList.vue?vue&type=script&lang=js&"
import style0 from "./LikersList.vue?vue&type=style&index=0&id=36808f21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36808f21",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36808f21')) {
      api.createRecord('36808f21', component.options)
    } else {
      api.reload('36808f21', component.options)
    }
    module.hot.accept("./LikersList.vue?vue&type=template&id=36808f21&scoped=true&", function () {
      api.rerender('36808f21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/Preview/Post/LikersCount/LikersList.vue"
export default component.exports